/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { GenericEmailDto } from '../models/generic-email-dto';
import { GoodsInFileDto } from '../models/goods-in-file-dto';
import { GoodsInFileDtoBaseResponse } from '../models/goods-in-file-dto-base-response';
import { GoodsInFileDtoListBaseResponse } from '../models/goods-in-file-dto-list-base-response';
import { GoodsInLineItemDto } from '../models/goods-in-line-item-dto';
import { GoodsInLineItemDtoPagedResponseBaseResponse } from '../models/goods-in-line-item-dto-paged-response-base-response';
import { GoodsInLineItemFileDto } from '../models/goods-in-line-item-file-dto';
import { GoodsInLineItemFileDtoBaseResponse } from '../models/goods-in-line-item-file-dto-base-response';
import { GoodsInLineItemFileDtoListBaseResponse } from '../models/goods-in-line-item-file-dto-list-base-response';
import { GoodsInReceiptDto } from '../models/goods-in-receipt-dto';
import { GoodsInReceiptDtoBaseResponse } from '../models/goods-in-receipt-dto-base-response';
import { GoodsInReceiptListDtoListBaseResponse } from '../models/goods-in-receipt-list-dto-list-base-response';
import { GoodsInReceiptListDtoPagedResponseBaseResponse } from '../models/goods-in-receipt-list-dto-paged-response-base-response';
import { Int32BaseResponse } from '../models/int-32-base-response';
import { OrderDirection } from '../models/order-direction';
import { PropertyFilter } from '../models/property-filter';
import { StockAdjustmentDto } from '../models/stock-adjustment-dto';
import { StockAdjustmentDtoBaseResponse } from '../models/stock-adjustment-dto-base-response';
import { StockAdjustmentDtoPagedResponseBaseResponse } from '../models/stock-adjustment-dto-paged-response-base-response';
import { StockReservationDto } from '../models/stock-reservation-dto';
import { StockReservationDtoBaseResponse } from '../models/stock-reservation-dto-base-response';
import { StockReservationDtoPagedResponseBaseResponse } from '../models/stock-reservation-dto-paged-response-base-response';
import { StringBaseResponse } from '../models/string-base-response';

@Injectable({
  providedIn: 'root',
})
export class GoodsInService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiGoodsInPaginatedListGet
   */
  static readonly ApiGoodsInPaginatedListGetPath = '/api/GoodsIn/paginated-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInPaginatedListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedListGet$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<GoodsInReceiptListDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInPaginatedListGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInReceiptListDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInPaginatedListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedListGet$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<GoodsInReceiptListDtoPagedResponseBaseResponse> {

    return this.apiGoodsInPaginatedListGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInReceiptListDtoPagedResponseBaseResponse>) => r.body as GoodsInReceiptListDtoPagedResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInPaginatedListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedListGet$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<GoodsInReceiptListDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInPaginatedListGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInReceiptListDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInPaginatedListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedListGet$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<GoodsInReceiptListDtoPagedResponseBaseResponse> {

    return this.apiGoodsInPaginatedListGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInReceiptListDtoPagedResponseBaseResponse>) => r.body as GoodsInReceiptListDtoPagedResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInGetGoodsInGet
   */
  static readonly ApiGoodsInGetGoodsInGetPath = '/api/GoodsIn/get-goods-in';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetGoodsInGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetGoodsInGet$Plain$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<GoodsInReceiptDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetGoodsInGetPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInReceiptDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetGoodsInGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetGoodsInGet$Plain(params?: {
    id?: number;
  }): Observable<GoodsInReceiptDtoBaseResponse> {

    return this.apiGoodsInGetGoodsInGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInReceiptDtoBaseResponse>) => r.body as GoodsInReceiptDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetGoodsInGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetGoodsInGet$Json$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<GoodsInReceiptDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetGoodsInGetPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInReceiptDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetGoodsInGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetGoodsInGet$Json(params?: {
    id?: number;
  }): Observable<GoodsInReceiptDtoBaseResponse> {

    return this.apiGoodsInGetGoodsInGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInReceiptDtoBaseResponse>) => r.body as GoodsInReceiptDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInGetForPurchaseOrderGet
   */
  static readonly ApiGoodsInGetForPurchaseOrderGetPath = '/api/GoodsIn/get-for-purchase-order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetForPurchaseOrderGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetForPurchaseOrderGet$Plain$Response(params?: {
    purchaseOrderId?: number;
  }): Observable<StrictHttpResponse<GoodsInReceiptListDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetForPurchaseOrderGetPath, 'get');
    if (params) {
      rb.query('purchaseOrderId', params.purchaseOrderId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInReceiptListDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetForPurchaseOrderGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetForPurchaseOrderGet$Plain(params?: {
    purchaseOrderId?: number;
  }): Observable<GoodsInReceiptListDtoListBaseResponse> {

    return this.apiGoodsInGetForPurchaseOrderGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInReceiptListDtoListBaseResponse>) => r.body as GoodsInReceiptListDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetForPurchaseOrderGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetForPurchaseOrderGet$Json$Response(params?: {
    purchaseOrderId?: number;
  }): Observable<StrictHttpResponse<GoodsInReceiptListDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetForPurchaseOrderGetPath, 'get');
    if (params) {
      rb.query('purchaseOrderId', params.purchaseOrderId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInReceiptListDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetForPurchaseOrderGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetForPurchaseOrderGet$Json(params?: {
    purchaseOrderId?: number;
  }): Observable<GoodsInReceiptListDtoListBaseResponse> {

    return this.apiGoodsInGetForPurchaseOrderGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInReceiptListDtoListBaseResponse>) => r.body as GoodsInReceiptListDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInAddGoodsInPost
   */
  static readonly ApiGoodsInAddGoodsInPostPath = '/api/GoodsIn/add-goods-in';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInAddGoodsInPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInAddGoodsInPost$Plain$Response(params?: {
    body?: GoodsInReceiptDto
  }): Observable<StrictHttpResponse<GoodsInReceiptDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInAddGoodsInPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInReceiptDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInAddGoodsInPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInAddGoodsInPost$Plain(params?: {
    body?: GoodsInReceiptDto
  }): Observable<GoodsInReceiptDtoBaseResponse> {

    return this.apiGoodsInAddGoodsInPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInReceiptDtoBaseResponse>) => r.body as GoodsInReceiptDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInAddGoodsInPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInAddGoodsInPost$Json$Response(params?: {
    body?: GoodsInReceiptDto
  }): Observable<StrictHttpResponse<GoodsInReceiptDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInAddGoodsInPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInReceiptDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInAddGoodsInPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInAddGoodsInPost$Json(params?: {
    body?: GoodsInReceiptDto
  }): Observable<GoodsInReceiptDtoBaseResponse> {

    return this.apiGoodsInAddGoodsInPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInReceiptDtoBaseResponse>) => r.body as GoodsInReceiptDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInUpdateGoodsInPost
   */
  static readonly ApiGoodsInUpdateGoodsInPostPath = '/api/GoodsIn/update-goods-in';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateGoodsInPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateGoodsInPost$Plain$Response(params?: {
    body?: GoodsInReceiptDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateGoodsInPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateGoodsInPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateGoodsInPost$Plain(params?: {
    body?: GoodsInReceiptDto
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInUpdateGoodsInPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateGoodsInPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateGoodsInPost$Json$Response(params?: {
    body?: GoodsInReceiptDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateGoodsInPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateGoodsInPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateGoodsInPost$Json(params?: {
    body?: GoodsInReceiptDto
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInUpdateGoodsInPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInToggleArchiveGoodsInPost
   */
  static readonly ApiGoodsInToggleArchiveGoodsInPostPath = '/api/GoodsIn/toggle-archive-goods-in';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInToggleArchiveGoodsInPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInToggleArchiveGoodsInPost$Plain$Response(params?: {
    goodsInReceiptId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInToggleArchiveGoodsInPostPath, 'post');
    if (params) {
      rb.query('goodsInReceiptId', params.goodsInReceiptId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInToggleArchiveGoodsInPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInToggleArchiveGoodsInPost$Plain(params?: {
    goodsInReceiptId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInToggleArchiveGoodsInPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInToggleArchiveGoodsInPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInToggleArchiveGoodsInPost$Json$Response(params?: {
    goodsInReceiptId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInToggleArchiveGoodsInPostPath, 'post');
    if (params) {
      rb.query('goodsInReceiptId', params.goodsInReceiptId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInToggleArchiveGoodsInPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInToggleArchiveGoodsInPost$Json(params?: {
    goodsInReceiptId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInToggleArchiveGoodsInPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInPaginatedQuarantineItemsPost
   */
  static readonly ApiGoodsInPaginatedQuarantineItemsPostPath = '/api/GoodsIn/paginated-quarantine-items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInPaginatedQuarantineItemsPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedQuarantineItemsPost$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<GoodsInLineItemDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInPaginatedQuarantineItemsPostPath, 'post');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInLineItemDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInPaginatedQuarantineItemsPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedQuarantineItemsPost$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<GoodsInLineItemDtoPagedResponseBaseResponse> {

    return this.apiGoodsInPaginatedQuarantineItemsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInLineItemDtoPagedResponseBaseResponse>) => r.body as GoodsInLineItemDtoPagedResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInPaginatedQuarantineItemsPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedQuarantineItemsPost$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<GoodsInLineItemDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInPaginatedQuarantineItemsPostPath, 'post');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInLineItemDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInPaginatedQuarantineItemsPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedQuarantineItemsPost$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<GoodsInLineItemDtoPagedResponseBaseResponse> {

    return this.apiGoodsInPaginatedQuarantineItemsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInLineItemDtoPagedResponseBaseResponse>) => r.body as GoodsInLineItemDtoPagedResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInUpdateQuarantineItemPost
   */
  static readonly ApiGoodsInUpdateQuarantineItemPostPath = '/api/GoodsIn/update-quarantine-item';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateQuarantineItemPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateQuarantineItemPost$Plain$Response(params?: {
    body?: GoodsInLineItemDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateQuarantineItemPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateQuarantineItemPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateQuarantineItemPost$Plain(params?: {
    body?: GoodsInLineItemDto
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInUpdateQuarantineItemPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateQuarantineItemPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateQuarantineItemPost$Json$Response(params?: {
    body?: GoodsInLineItemDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateQuarantineItemPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateQuarantineItemPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateQuarantineItemPost$Json(params?: {
    body?: GoodsInLineItemDto
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInUpdateQuarantineItemPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInGetGrnRefPost
   */
  static readonly ApiGoodsInGetGrnRefPostPath = '/api/GoodsIn/get-grn-ref';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetGrnRefPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInGetGrnRefPost$Plain$Response(params?: {
    body?: GoodsInReceiptDto
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetGrnRefPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetGrnRefPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInGetGrnRefPost$Plain(params?: {
    body?: GoodsInReceiptDto
  }): Observable<StringBaseResponse> {

    return this.apiGoodsInGetGrnRefPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetGrnRefPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInGetGrnRefPost$Json$Response(params?: {
    body?: GoodsInReceiptDto
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetGrnRefPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetGrnRefPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInGetGrnRefPost$Json(params?: {
    body?: GoodsInReceiptDto
  }): Observable<StringBaseResponse> {

    return this.apiGoodsInGetGrnRefPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInGetNextGrnRefGet
   */
  static readonly ApiGoodsInGetNextGrnRefGetPath = '/api/GoodsIn/get-next-grn-ref';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetNextGrnRefGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetNextGrnRefGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetNextGrnRefGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetNextGrnRefGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetNextGrnRefGet$Plain(params?: {
  }): Observable<StringBaseResponse> {

    return this.apiGoodsInGetNextGrnRefGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetNextGrnRefGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetNextGrnRefGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetNextGrnRefGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetNextGrnRefGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetNextGrnRefGet$Json(params?: {
  }): Observable<StringBaseResponse> {

    return this.apiGoodsInGetNextGrnRefGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInGetStockReservationGet
   */
  static readonly ApiGoodsInGetStockReservationGetPath = '/api/GoodsIn/get-stock-reservation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetStockReservationGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetStockReservationGet$Plain$Response(params?: {
    reservationId?: number;
  }): Observable<StrictHttpResponse<StockReservationDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetStockReservationGetPath, 'get');
    if (params) {
      rb.query('reservationId', params.reservationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockReservationDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetStockReservationGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetStockReservationGet$Plain(params?: {
    reservationId?: number;
  }): Observable<StockReservationDtoBaseResponse> {

    return this.apiGoodsInGetStockReservationGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StockReservationDtoBaseResponse>) => r.body as StockReservationDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetStockReservationGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetStockReservationGet$Json$Response(params?: {
    reservationId?: number;
  }): Observable<StrictHttpResponse<StockReservationDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetStockReservationGetPath, 'get');
    if (params) {
      rb.query('reservationId', params.reservationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockReservationDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetStockReservationGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetStockReservationGet$Json(params?: {
    reservationId?: number;
  }): Observable<StockReservationDtoBaseResponse> {

    return this.apiGoodsInGetStockReservationGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StockReservationDtoBaseResponse>) => r.body as StockReservationDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInUpdateReservedCountGet
   */
  static readonly ApiGoodsInUpdateReservedCountGetPath = '/api/GoodsIn/update-reserved-count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateReservedCountGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInUpdateReservedCountGet$Plain$Response(params?: {
    partId?: number;
  }): Observable<StrictHttpResponse<Int32BaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateReservedCountGetPath, 'get');
    if (params) {
      rb.query('partId', params.partId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Int32BaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateReservedCountGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInUpdateReservedCountGet$Plain(params?: {
    partId?: number;
  }): Observable<Int32BaseResponse> {

    return this.apiGoodsInUpdateReservedCountGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Int32BaseResponse>) => r.body as Int32BaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateReservedCountGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInUpdateReservedCountGet$Json$Response(params?: {
    partId?: number;
  }): Observable<StrictHttpResponse<Int32BaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateReservedCountGetPath, 'get');
    if (params) {
      rb.query('partId', params.partId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Int32BaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateReservedCountGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInUpdateReservedCountGet$Json(params?: {
    partId?: number;
  }): Observable<Int32BaseResponse> {

    return this.apiGoodsInUpdateReservedCountGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Int32BaseResponse>) => r.body as Int32BaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInPaginatedStockReservationsPost
   */
  static readonly ApiGoodsInPaginatedStockReservationsPostPath = '/api/GoodsIn/paginated-stock-reservations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInPaginatedStockReservationsPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedStockReservationsPost$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<StockReservationDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInPaginatedStockReservationsPostPath, 'post');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockReservationDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInPaginatedStockReservationsPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedStockReservationsPost$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StockReservationDtoPagedResponseBaseResponse> {

    return this.apiGoodsInPaginatedStockReservationsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StockReservationDtoPagedResponseBaseResponse>) => r.body as StockReservationDtoPagedResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInPaginatedStockReservationsPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedStockReservationsPost$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<StockReservationDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInPaginatedStockReservationsPostPath, 'post');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockReservationDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInPaginatedStockReservationsPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedStockReservationsPost$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StockReservationDtoPagedResponseBaseResponse> {

    return this.apiGoodsInPaginatedStockReservationsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StockReservationDtoPagedResponseBaseResponse>) => r.body as StockReservationDtoPagedResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInAddStockReservationPost
   */
  static readonly ApiGoodsInAddStockReservationPostPath = '/api/GoodsIn/add-stock-reservation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInAddStockReservationPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInAddStockReservationPost$Plain$Response(params?: {
    body?: StockReservationDto
  }): Observable<StrictHttpResponse<StockReservationDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInAddStockReservationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockReservationDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInAddStockReservationPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInAddStockReservationPost$Plain(params?: {
    body?: StockReservationDto
  }): Observable<StockReservationDtoBaseResponse> {

    return this.apiGoodsInAddStockReservationPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StockReservationDtoBaseResponse>) => r.body as StockReservationDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInAddStockReservationPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInAddStockReservationPost$Json$Response(params?: {
    body?: StockReservationDto
  }): Observable<StrictHttpResponse<StockReservationDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInAddStockReservationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockReservationDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInAddStockReservationPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInAddStockReservationPost$Json(params?: {
    body?: StockReservationDto
  }): Observable<StockReservationDtoBaseResponse> {

    return this.apiGoodsInAddStockReservationPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StockReservationDtoBaseResponse>) => r.body as StockReservationDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInUpdateStockReservationPut
   */
  static readonly ApiGoodsInUpdateStockReservationPutPath = '/api/GoodsIn/update-stock-reservation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateStockReservationPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateStockReservationPut$Plain$Response(params?: {
    body?: StockReservationDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateStockReservationPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateStockReservationPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateStockReservationPut$Plain(params?: {
    body?: StockReservationDto
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInUpdateStockReservationPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateStockReservationPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateStockReservationPut$Json$Response(params?: {
    body?: StockReservationDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateStockReservationPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateStockReservationPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateStockReservationPut$Json(params?: {
    body?: StockReservationDto
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInUpdateStockReservationPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInToggleArchiveStockReservationPost
   */
  static readonly ApiGoodsInToggleArchiveStockReservationPostPath = '/api/GoodsIn/toggle-archive-stock-reservation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInToggleArchiveStockReservationPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInToggleArchiveStockReservationPost$Plain$Response(params?: {
    stockReservationId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInToggleArchiveStockReservationPostPath, 'post');
    if (params) {
      rb.query('stockReservationId', params.stockReservationId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInToggleArchiveStockReservationPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInToggleArchiveStockReservationPost$Plain(params?: {
    stockReservationId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInToggleArchiveStockReservationPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInToggleArchiveStockReservationPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInToggleArchiveStockReservationPost$Json$Response(params?: {
    stockReservationId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInToggleArchiveStockReservationPostPath, 'post');
    if (params) {
      rb.query('stockReservationId', params.stockReservationId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInToggleArchiveStockReservationPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInToggleArchiveStockReservationPost$Json(params?: {
    stockReservationId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInToggleArchiveStockReservationPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInGetStockAdjustmentGet
   */
  static readonly ApiGoodsInGetStockAdjustmentGetPath = '/api/GoodsIn/get-stock-adjustment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetStockAdjustmentGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetStockAdjustmentGet$Plain$Response(params?: {
    adjustmentId?: number;
  }): Observable<StrictHttpResponse<StockAdjustmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetStockAdjustmentGetPath, 'get');
    if (params) {
      rb.query('adjustmentId', params.adjustmentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockAdjustmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetStockAdjustmentGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetStockAdjustmentGet$Plain(params?: {
    adjustmentId?: number;
  }): Observable<StockAdjustmentDtoBaseResponse> {

    return this.apiGoodsInGetStockAdjustmentGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StockAdjustmentDtoBaseResponse>) => r.body as StockAdjustmentDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetStockAdjustmentGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetStockAdjustmentGet$Json$Response(params?: {
    adjustmentId?: number;
  }): Observable<StrictHttpResponse<StockAdjustmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetStockAdjustmentGetPath, 'get');
    if (params) {
      rb.query('adjustmentId', params.adjustmentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockAdjustmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetStockAdjustmentGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetStockAdjustmentGet$Json(params?: {
    adjustmentId?: number;
  }): Observable<StockAdjustmentDtoBaseResponse> {

    return this.apiGoodsInGetStockAdjustmentGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StockAdjustmentDtoBaseResponse>) => r.body as StockAdjustmentDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInPaginatedStockAdjustmentsPost
   */
  static readonly ApiGoodsInPaginatedStockAdjustmentsPostPath = '/api/GoodsIn/paginated-stock-adjustments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInPaginatedStockAdjustmentsPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedStockAdjustmentsPost$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<StockAdjustmentDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInPaginatedStockAdjustmentsPostPath, 'post');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockAdjustmentDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInPaginatedStockAdjustmentsPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedStockAdjustmentsPost$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StockAdjustmentDtoPagedResponseBaseResponse> {

    return this.apiGoodsInPaginatedStockAdjustmentsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StockAdjustmentDtoPagedResponseBaseResponse>) => r.body as StockAdjustmentDtoPagedResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInPaginatedStockAdjustmentsPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedStockAdjustmentsPost$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<StockAdjustmentDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInPaginatedStockAdjustmentsPostPath, 'post');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockAdjustmentDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInPaginatedStockAdjustmentsPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInPaginatedStockAdjustmentsPost$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StockAdjustmentDtoPagedResponseBaseResponse> {

    return this.apiGoodsInPaginatedStockAdjustmentsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StockAdjustmentDtoPagedResponseBaseResponse>) => r.body as StockAdjustmentDtoPagedResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInAddStockAdjustmentPost
   */
  static readonly ApiGoodsInAddStockAdjustmentPostPath = '/api/GoodsIn/add-stock-adjustment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInAddStockAdjustmentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInAddStockAdjustmentPost$Plain$Response(params?: {
    body?: StockAdjustmentDto
  }): Observable<StrictHttpResponse<StockAdjustmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInAddStockAdjustmentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockAdjustmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInAddStockAdjustmentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInAddStockAdjustmentPost$Plain(params?: {
    body?: StockAdjustmentDto
  }): Observable<StockAdjustmentDtoBaseResponse> {

    return this.apiGoodsInAddStockAdjustmentPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StockAdjustmentDtoBaseResponse>) => r.body as StockAdjustmentDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInAddStockAdjustmentPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInAddStockAdjustmentPost$Json$Response(params?: {
    body?: StockAdjustmentDto
  }): Observable<StrictHttpResponse<StockAdjustmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInAddStockAdjustmentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockAdjustmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInAddStockAdjustmentPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInAddStockAdjustmentPost$Json(params?: {
    body?: StockAdjustmentDto
  }): Observable<StockAdjustmentDtoBaseResponse> {

    return this.apiGoodsInAddStockAdjustmentPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StockAdjustmentDtoBaseResponse>) => r.body as StockAdjustmentDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInUpdateStockAdjustmentPut
   */
  static readonly ApiGoodsInUpdateStockAdjustmentPutPath = '/api/GoodsIn/update-stock-adjustment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateStockAdjustmentPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateStockAdjustmentPut$Plain$Response(params?: {
    body?: StockAdjustmentDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateStockAdjustmentPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateStockAdjustmentPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateStockAdjustmentPut$Plain(params?: {
    body?: StockAdjustmentDto
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInUpdateStockAdjustmentPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateStockAdjustmentPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateStockAdjustmentPut$Json$Response(params?: {
    body?: StockAdjustmentDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateStockAdjustmentPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateStockAdjustmentPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateStockAdjustmentPut$Json(params?: {
    body?: StockAdjustmentDto
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInUpdateStockAdjustmentPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInSendRmaEmailPost
   */
  static readonly ApiGoodsInSendRmaEmailPostPath = '/api/GoodsIn/send-rma-email';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInSendRmaEmailPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInSendRmaEmailPost$Plain$Response(params?: {
    goodsInLineItemId?: number;
    body?: GenericEmailDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInSendRmaEmailPostPath, 'post');
    if (params) {
      rb.query('goodsInLineItemId', params.goodsInLineItemId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInSendRmaEmailPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInSendRmaEmailPost$Plain(params?: {
    goodsInLineItemId?: number;
    body?: GenericEmailDto
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInSendRmaEmailPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInSendRmaEmailPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInSendRmaEmailPost$Json$Response(params?: {
    goodsInLineItemId?: number;
    body?: GenericEmailDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInSendRmaEmailPostPath, 'post');
    if (params) {
      rb.query('goodsInLineItemId', params.goodsInLineItemId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInSendRmaEmailPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInSendRmaEmailPost$Json(params?: {
    goodsInLineItemId?: number;
    body?: GenericEmailDto
  }): Observable<BooleanBaseResponse> {

    return this.apiGoodsInSendRmaEmailPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInGetFilesGet
   */
  static readonly ApiGoodsInGetFilesGetPath = '/api/GoodsIn/get-files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetFilesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetFilesGet$Plain$Response(params?: {
    goodsInReceiptId?: number;
  }): Observable<StrictHttpResponse<GoodsInFileDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetFilesGetPath, 'get');
    if (params) {
      rb.query('goodsInReceiptId', params.goodsInReceiptId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInFileDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetFilesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetFilesGet$Plain(params?: {
    goodsInReceiptId?: number;
  }): Observable<GoodsInFileDtoListBaseResponse> {

    return this.apiGoodsInGetFilesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInFileDtoListBaseResponse>) => r.body as GoodsInFileDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetFilesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetFilesGet$Json$Response(params?: {
    goodsInReceiptId?: number;
  }): Observable<StrictHttpResponse<GoodsInFileDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetFilesGetPath, 'get');
    if (params) {
      rb.query('goodsInReceiptId', params.goodsInReceiptId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInFileDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetFilesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetFilesGet$Json(params?: {
    goodsInReceiptId?: number;
  }): Observable<GoodsInFileDtoListBaseResponse> {

    return this.apiGoodsInGetFilesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInFileDtoListBaseResponse>) => r.body as GoodsInFileDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInUploadFileGoodsInReceiptIdPost
   */
  static readonly ApiGoodsInUploadFileGoodsInReceiptIdPostPath = '/api/GoodsIn/upload-file/{goodsInReceiptId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUploadFileGoodsInReceiptIdPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiGoodsInUploadFileGoodsInReceiptIdPost$Plain$Response(params: {
    goodsInReceiptId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<GoodsInFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUploadFileGoodsInReceiptIdPostPath, 'post');
    if (params) {
      rb.path('goodsInReceiptId', params.goodsInReceiptId, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUploadFileGoodsInReceiptIdPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiGoodsInUploadFileGoodsInReceiptIdPost$Plain(params: {
    goodsInReceiptId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<GoodsInFileDtoBaseResponse> {

    return this.apiGoodsInUploadFileGoodsInReceiptIdPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInFileDtoBaseResponse>) => r.body as GoodsInFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUploadFileGoodsInReceiptIdPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiGoodsInUploadFileGoodsInReceiptIdPost$Json$Response(params: {
    goodsInReceiptId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<GoodsInFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUploadFileGoodsInReceiptIdPostPath, 'post');
    if (params) {
      rb.path('goodsInReceiptId', params.goodsInReceiptId, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUploadFileGoodsInReceiptIdPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiGoodsInUploadFileGoodsInReceiptIdPost$Json(params: {
    goodsInReceiptId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<GoodsInFileDtoBaseResponse> {

    return this.apiGoodsInUploadFileGoodsInReceiptIdPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInFileDtoBaseResponse>) => r.body as GoodsInFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInUpdateFilePost
   */
  static readonly ApiGoodsInUpdateFilePostPath = '/api/GoodsIn/update-file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateFilePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateFilePost$Plain$Response(params?: {
    body?: GoodsInFileDto
  }): Observable<StrictHttpResponse<GoodsInFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateFilePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateFilePost$Plain(params?: {
    body?: GoodsInFileDto
  }): Observable<GoodsInFileDtoBaseResponse> {

    return this.apiGoodsInUpdateFilePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInFileDtoBaseResponse>) => r.body as GoodsInFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateFilePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateFilePost$Json$Response(params?: {
    body?: GoodsInFileDto
  }): Observable<StrictHttpResponse<GoodsInFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateFilePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateFilePost$Json(params?: {
    body?: GoodsInFileDto
  }): Observable<GoodsInFileDtoBaseResponse> {

    return this.apiGoodsInUpdateFilePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInFileDtoBaseResponse>) => r.body as GoodsInFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInDownloadFileFileIdGet
   */
  static readonly ApiGoodsInDownloadFileFileIdGetPath = '/api/GoodsIn/download-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInDownloadFileFileIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInDownloadFileFileIdGet$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInDownloadFileFileIdGetPath, 'get');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInDownloadFileFileIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInDownloadFileFileIdGet(params: {
    fileId: number;
  }): Observable<string> {

    return this.apiGoodsInDownloadFileFileIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiGoodsInDeleteFileFileIdDelete
   */
  static readonly ApiGoodsInDeleteFileFileIdDeletePath = '/api/GoodsIn/delete-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInDeleteFileFileIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInDeleteFileFileIdDelete$Plain$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<GoodsInFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInDeleteFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInDeleteFileFileIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInDeleteFileFileIdDelete$Plain(params: {
    fileId: number;
  }): Observable<GoodsInFileDtoBaseResponse> {

    return this.apiGoodsInDeleteFileFileIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInFileDtoBaseResponse>) => r.body as GoodsInFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInDeleteFileFileIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInDeleteFileFileIdDelete$Json$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<GoodsInFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInDeleteFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInDeleteFileFileIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInDeleteFileFileIdDelete$Json(params: {
    fileId: number;
  }): Observable<GoodsInFileDtoBaseResponse> {

    return this.apiGoodsInDeleteFileFileIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInFileDtoBaseResponse>) => r.body as GoodsInFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInGetLineItemFilesGet
   */
  static readonly ApiGoodsInGetLineItemFilesGetPath = '/api/GoodsIn/get-line-item-files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetLineItemFilesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetLineItemFilesGet$Plain$Response(params?: {
    goodsInLineItemId?: number;
  }): Observable<StrictHttpResponse<GoodsInLineItemFileDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetLineItemFilesGetPath, 'get');
    if (params) {
      rb.query('goodsInLineItemId', params.goodsInLineItemId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInLineItemFileDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetLineItemFilesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetLineItemFilesGet$Plain(params?: {
    goodsInLineItemId?: number;
  }): Observable<GoodsInLineItemFileDtoListBaseResponse> {

    return this.apiGoodsInGetLineItemFilesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInLineItemFileDtoListBaseResponse>) => r.body as GoodsInLineItemFileDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInGetLineItemFilesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetLineItemFilesGet$Json$Response(params?: {
    goodsInLineItemId?: number;
  }): Observable<StrictHttpResponse<GoodsInLineItemFileDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInGetLineItemFilesGetPath, 'get');
    if (params) {
      rb.query('goodsInLineItemId', params.goodsInLineItemId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInLineItemFileDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInGetLineItemFilesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInGetLineItemFilesGet$Json(params?: {
    goodsInLineItemId?: number;
  }): Observable<GoodsInLineItemFileDtoListBaseResponse> {

    return this.apiGoodsInGetLineItemFilesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInLineItemFileDtoListBaseResponse>) => r.body as GoodsInLineItemFileDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInUploadLineItemFileGoodsInLineItemIdPost
   */
  static readonly ApiGoodsInUploadLineItemFileGoodsInLineItemIdPostPath = '/api/GoodsIn/upload-line-item-file/{goodsInLineItemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUploadLineItemFileGoodsInLineItemIdPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiGoodsInUploadLineItemFileGoodsInLineItemIdPost$Plain$Response(params: {
    goodsInLineItemId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUploadLineItemFileGoodsInLineItemIdPostPath, 'post');
    if (params) {
      rb.path('goodsInLineItemId', params.goodsInLineItemId, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUploadLineItemFileGoodsInLineItemIdPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiGoodsInUploadLineItemFileGoodsInLineItemIdPost$Plain(params: {
    goodsInLineItemId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<GoodsInLineItemFileDtoBaseResponse> {

    return this.apiGoodsInUploadLineItemFileGoodsInLineItemIdPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>) => r.body as GoodsInLineItemFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUploadLineItemFileGoodsInLineItemIdPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiGoodsInUploadLineItemFileGoodsInLineItemIdPost$Json$Response(params: {
    goodsInLineItemId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUploadLineItemFileGoodsInLineItemIdPostPath, 'post');
    if (params) {
      rb.path('goodsInLineItemId', params.goodsInLineItemId, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUploadLineItemFileGoodsInLineItemIdPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiGoodsInUploadLineItemFileGoodsInLineItemIdPost$Json(params: {
    goodsInLineItemId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<GoodsInLineItemFileDtoBaseResponse> {

    return this.apiGoodsInUploadLineItemFileGoodsInLineItemIdPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>) => r.body as GoodsInLineItemFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInUpdateLineItemFilePost
   */
  static readonly ApiGoodsInUpdateLineItemFilePostPath = '/api/GoodsIn/update-line-item-file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateLineItemFilePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateLineItemFilePost$Plain$Response(params?: {
    body?: GoodsInLineItemFileDto
  }): Observable<StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateLineItemFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateLineItemFilePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateLineItemFilePost$Plain(params?: {
    body?: GoodsInLineItemFileDto
  }): Observable<GoodsInLineItemFileDtoBaseResponse> {

    return this.apiGoodsInUpdateLineItemFilePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>) => r.body as GoodsInLineItemFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInUpdateLineItemFilePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateLineItemFilePost$Json$Response(params?: {
    body?: GoodsInLineItemFileDto
  }): Observable<StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInUpdateLineItemFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInUpdateLineItemFilePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGoodsInUpdateLineItemFilePost$Json(params?: {
    body?: GoodsInLineItemFileDto
  }): Observable<GoodsInLineItemFileDtoBaseResponse> {

    return this.apiGoodsInUpdateLineItemFilePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>) => r.body as GoodsInLineItemFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiGoodsInDownloadLineItemFileFileIdGet
   */
  static readonly ApiGoodsInDownloadLineItemFileFileIdGetPath = '/api/GoodsIn/download-line-item-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInDownloadLineItemFileFileIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInDownloadLineItemFileFileIdGet$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInDownloadLineItemFileFileIdGetPath, 'get');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInDownloadLineItemFileFileIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInDownloadLineItemFileFileIdGet(params: {
    fileId: number;
  }): Observable<string> {

    return this.apiGoodsInDownloadLineItemFileFileIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiGoodsInDeleteLineItemFileFileIdDelete
   */
  static readonly ApiGoodsInDeleteLineItemFileFileIdDeletePath = '/api/GoodsIn/delete-line-item-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInDeleteLineItemFileFileIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInDeleteLineItemFileFileIdDelete$Plain$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInDeleteLineItemFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInDeleteLineItemFileFileIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInDeleteLineItemFileFileIdDelete$Plain(params: {
    fileId: number;
  }): Observable<GoodsInLineItemFileDtoBaseResponse> {

    return this.apiGoodsInDeleteLineItemFileFileIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>) => r.body as GoodsInLineItemFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGoodsInDeleteLineItemFileFileIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInDeleteLineItemFileFileIdDelete$Json$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoodsInService.ApiGoodsInDeleteLineItemFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGoodsInDeleteLineItemFileFileIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGoodsInDeleteLineItemFileFileIdDelete$Json(params: {
    fileId: number;
  }): Observable<GoodsInLineItemFileDtoBaseResponse> {

    return this.apiGoodsInDeleteLineItemFileFileIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GoodsInLineItemFileDtoBaseResponse>) => r.body as GoodsInLineItemFileDtoBaseResponse)
    );
  }

}
